import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from './Select';

import {
  inputDefaultProps,
  inputPropTypes,
  metaDefaultProps,
  metaPropTypes,
} from '../input/InputPropTypes';
import {
  clearBaggageDiscountCodes,
  getBaggageDiscountCodes,
} from '../../../../actions';

const BaggageDiscountCodeSelect = ({
  options,
  isLoading,
  onValueChange,
  input,
  meta,
  isClearable,
  isSpecial,
  dispatchGetBaggageDiscountCodes,
  dispatchClearBaggageDiscountCodes,
  ...args
}) => {
  useLayoutEffect(() => {
    dispatchGetBaggageDiscountCodes(isSpecial);
    return () => {
      dispatchClearBaggageDiscountCodes(isSpecial);
    };
  }, []);

  return (
    <Select
      isLoading={isLoading}
      options={options}
      onValueChange={onValueChange}
      input={input}
      meta={meta}
      isClearable={isClearable}
      {...args}
    />
  );
};

BaggageDiscountCodeSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onValueChange: PropTypes.func,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  meta: metaPropTypes,
  isClearable: PropTypes.bool,
  isSpecial: PropTypes.bool,
  dispatchGetBaggageDiscountCodes: PropTypes.func.isRequired,
  dispatchClearBaggageDiscountCodes: PropTypes.func.isRequired,
};

BaggageDiscountCodeSelect.defaultProps = {
  onValueChange: undefined,
  isMulti: false,
  input: inputDefaultProps,
  meta: metaDefaultProps,
  isClearable: false,
  isSpecial: false,
};

const mapStateToProps = ({ BaggageUnit }, { isSpecial }) => ({
  options: BaggageUnit.BaggageDiscountCode.getIn([
    isSpecial ? 'special' : 'regular',
    'content',
    'content',
  ]).map(({ code, id, ...rest }) => ({
    label: code,
    value: id,
    code,
    id,
    ...rest
  })),
  isLoading: BaggageUnit.BaggageDiscountCode.getIn([
    isSpecial ? 'special' : 'regular',
    'loading',
  ]),
});

const mapDispatchToProps = {
  dispatchGetBaggageDiscountCodes: getBaggageDiscountCodes,
  dispatchClearBaggageDiscountCodes: clearBaggageDiscountCodes,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BaggageDiscountCodeSelect);
